// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudFilledSvg from "@ant-design/icons-svg/es/asn/CloudFilled";
import AntdIcon from '../components/AntdIcon';

var CloudFilled = function CloudFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudFilledSvg
  }));
};

CloudFilled.displayName = 'CloudFilled';
export default React.forwardRef(CloudFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloudFilled.js
// module id = 799
// module chunks = 0